import type { CatalogMatch } from "@/lib/manufacturing/spokenCatalogMatch";

/** Post-dictation cleanup list: what we heard, then the catalog guess. */
export function SpokenCatalogMatchList(props: {
  matches: CatalogMatch[];
  appliedCount?: number;
  emptyHint?: string | null;
}) {
  if (props.matches.length === 0) {
    if (!props.emptyHint) return null;
    return (
      <p className="mt-2 text-[11px] text-amber-800 dark:text-amber-200">{props.emptyHint}</p>
    );
  }
  const applied = props.appliedCount;
  return (
    <div className="mt-2 space-y-1">
      {props.emptyHint ? (
        <p className="text-[11px] text-amber-800 dark:text-amber-200">{props.emptyHint}</p>
      ) : null}
      <p className="text-[11px] font-medium text-gray-800 dark:text-zinc-100">
        Heard {props.matches.length} line{props.matches.length === 1 ? "" : "s"}
        {applied != null ? ` · ${applied} applied` : ""}
      </p>
      <ul className="space-y-1 text-[11px] text-gray-700 dark:text-zinc-300">
        {props.matches.map((m, i) => (
          <li key={`${m.spoken.raw}-${i}`}>
            {m.spoken.qty} × {m.spoken.name}
            {m.status === "unmatched"
              ? " — no catalog match"
              : ` → ${m.candidate?.name ?? ""} (${m.status})`}
          </li>
        ))}
      </ul>
    </div>
  );
}
